import { InteractiveFile } from "../../backend/interactiveTypes";
import {
  ExtendedRepositoryObject,
  PmxActivity,
  Repo,
  RepositoryObject,
  RepositoryTree
} from "../../backend/types";
import { getTreeHierarchyFromRepositoryObjects } from "../../helpers/treeHelper";

const getAllRepos = (activityData: PmxActivity): Repo[] => {
  if (activityData) {
    const repos = [
      ...(Array.isArray(activityData.readOnlyRepositories)
        ? activityData.readOnlyRepositories.filter(
            (repo: Repo | null | undefined): repo is Repo => !!repo
          )
        : []),
      activityData.mainRepository
    ];

    return repos;
  }
  return [];
};

export const castingFilesToRepObjectTree = (
  interactiveFiles: InteractiveFile[],
  activityData: PmxActivity
): RepositoryTree[] => {
  const repos = getAllRepos(activityData);
  const repositoryObjects: RepositoryObject[] = [];

  interactiveFiles.forEach((file) => {
    // Add file
    repositoryObjects.push({
      name: file.path,
      versionId: "",
      repository: repos.find((repo) => repo.name === file.repoName)!
    });

    // Add folders in the path
    const subFolders = file.path.split("/").slice(0, -1);
    let folderPath = "";
    subFolders.forEach((sub) => {
      folderPath += sub + "/";
      if (
        !repositoryObjects.some(
          (obj: RepositoryObject) =>
            obj.name.endsWith("/") && obj.name === folderPath
        )
      ) {
        repositoryObjects.push({
          name: folderPath,
          versionId: "",
          repository: repos.find((repo) => repo.name === file.repoName)!
        });
      }
    });
  });

  let interactiveTree =
    getTreeHierarchyFromRepositoryObjects(repositoryObjects);
  return interactiveTree.sort((a: RepositoryTree, b: RepositoryTree) => {
    // Put main repository first
    if (a.repository.id === activityData.mainRepository.id) return -1;
    if (b.repository.id === activityData.mainRepository.id) return 1;
    return 0;
  });
};
